import Clients from "../../images/products/clients.png";
import fmiti from "../../images/products/fmiti_895x347.png";

const logos = [Clients, fmiti];

function ProductsClients() {
  return (
    <div className="products-partners">
      <h1>Clients that trust our work</h1>
      {/* <div className="products-partners-images">
        {Array.from({ length: 8 }).map((_, i) => (
          <img key={i} src={Clients} alt="clients" />
        ))}
      </div> */}
      <div className="products-partners-images">
        {logos.map((logo, i) => (
          <img key={i} src={logo} alt={`client-${i}`} />
        ))}
      </div>
      <canvas className="shape1" />
      <canvas className="shape2" />
    </div>
  );
}

export default ProductsClients;
